<template>
  <Base icon="mdi-office-building" :satisfied="requirement.satisfied" tooltip>
    <span>
      Experience
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} have
      {{ requirement.negative ? 'less than' : 'at least' }}
      <strong>{{ duration }}</strong> work experience
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  computed: {
    duration() {
      if (this.requirement.value % 12 == 0) {
        return `${this.requirement.value / 12} years`
      } else {
        return `${this.requirement.value} months`
      }
    },
  },
}
</script>
